import {
  BasketSummaryFilterRequest,
  BasketSummaryFilterResponse,
  BasketSummaryItem,
  BasketSummaryV2FilterResponse,
  basketSummary,
} from '@api/api/basket-summary';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

export const QUERY_KEY_BASKET_SUMMARY_FILTER =
  'QUERY_KEY_BASKET_SUMMARY_FILTER';

export const postBasketSummaryFilter = (
  body: BasketSummaryFilterRequest,
  signal?: AbortSignal
) => {
  const { path, schema } = basketSummary.postBasketSummaryFilter;

  return wretchRequest<BasketSummaryFilterResponse>(path, {
    method: 'post',
    body,
    schema,
    signal,
  });
};

export const postBasketSummaryFilterV2 = (
  body: BasketSummaryFilterRequest,
  signal?: AbortSignal
) => {
  const { path, schema } = basketSummary.postBasketSummaryFilterV2;

  return wretchRequest<BasketSummaryV2FilterResponse>(path, {
    method: 'post',
    body,
    schema,
    signal,
  });
};

export const postBasketSummaryFilterByVersion = ({
  body,
  isV2,
  signal,
}: {
  body: BasketSummaryFilterRequest;
  isV2: boolean;
  signal?: AbortSignal;
}): Promise<BasketSummaryItem[]> =>
  isV2
    ? postBasketSummaryFilterV2(body, signal)
    : postBasketSummaryFilter(body, signal);

export const findBasketSummary = <T extends BasketSummaryItem>({
  summaries,
  subjectId,
  summaryType,
}: {
  summaries: readonly T[];
  subjectId: string;
  summaryType: BasketSummaryItem['summary_type'];
}) =>
  summaries.find(
    summary =>
      summary.summary_type === summaryType && summary.subject.id === subjectId
  );
